const state = {
  categorias: null,
  currentCategoria: null
}

export default state
